import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { MotionDiv } from '@/components/element/MotionDiv';
import { useDashboardSearchCondition } from '@/providers/DashboardSearchConditionProvider';
import { usePurchaseDashboardAmountByOrder } from '@/hooks/api/2180_purchase_dashboard_amount_by_order';

export const AmountByOrder = () => {
  const { _w_ } = useCurrentWorkspace();
  const { purchaseOrdersDashboardSearchCondition: searchCondition, setPurchaseOrdersDashboardSearchCondition: setSearchCondition } =
    useDashboardSearchCondition();
  const { data } = usePurchaseDashboardAmountByOrder({ ...searchCondition, identifier: _w_!.identifier });

  if (!data || data.order_rankings.length == 0) return <></>;

  return (
    <MotionDiv className="col-lg-6 col-xl-4">
      <div className="card mb-4 mb-lg-3">
        <div className="card-header pb-0 p-3">
          <h6 className="mb-0">案件別</h6>
        </div>
        <div className="card-body">
          {data.order_rankings.map((d, i) => (
            <div key={`a-b-p-${i}`} className="progress-wrapper">
              <div className="d-flex align-items-center mb-2">
                <h6 className="text-xs mb-0">{d.name}</h6>
                <div className="flex-1 text-end text-xs text-mute">¥{d.total_amount.toLocaleString()}</div>
              </div>
              <div className="progress">
                <div className="progress-bar-sub" style={{ width: `${Math.trunc((d.total_amount / data.total_amount) * 100)}%` }}></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </MotionDiv>
  );
};
